import { gql } from "@apollo/client";

export const CREATE_BANKACCOUNT = gql`
  mutation createBankAccount($input: createBankAccountInput) {
    createBankAccount(input: $input) {
      employeeId
    }
  }
`;

export const UPDATE_BANKACCOUNT = gql`
  mutation updateBankAccount($input: updateBankAccountInput) {
    updateBankAccount(input: $input)
  }
`;
export const GET_BANKACCOUNTDETAILS_BYUSER = gql`
  query bankAccountDetailsByUser($employeeId: String!) {
    bankAccountDetailsByUser(employeeId: $employeeId) {
      accountNumber
      ifsc
      branch
      holderName
      bankName
      orgId
      employeeId
      Id
      reaccountNumber
      pfaccountNumber
      universalaccountNumber
    }
  }
`;
